import { render, staticRenderFns } from "./TrialReportsEditTabContent.vue?vue&type=template&id=88e2554a&"
import script from "./TrialReportsEditTabContent.vue?vue&type=script&lang=js&"
export * from "./TrialReportsEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./TrialReportsEditTabContent.vue?vue&type=style&index=0&id=88e2554a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports